import {UnitTypeDto, unitTypesDto} from "homey-housing-lottery-app-dto";

export type UnitType = UnitTypeDto;
export const unitTypes = unitTypesDto
